import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DOMAIN_FOR_PAGE_BASIC_ATTRIBUTES } from './fragment'
import { Data, Variables } from './types'

export const GET_DOMAINS_FOR_PAGE_BASIC_ATTRIBUTES: TypedDocumentNode<Data, Variables> = gql`
  ${DOMAIN_FOR_PAGE_BASIC_ATTRIBUTES}

  query getDomainsForPageBasicAttributes($workspaceId: ID!) {
    domains(workspaceId: $workspaceId) {
      nodes {
        ...DomainForPageBasicAttributes
      }
    }
  }
`
